export function GuestLoginModel() {
    this.contactNumber = null;
    this.name = null;
    this.terms = 1;
    this.privacy = 1;
    this.market = 1;

    this.getParams = function () { 
        let params = {
            contactNumber: this.contactNumber,
            name: this.name,
            termandcondition: this.terms,
            dataprivacy: this.privacy,
            marketingOption: this.market,
        };

        return params;
    };
}

export function GuestLoginModelBuilder() {
    this.guestModel = new GuestLoginModel();

    this.create = function () { 
        return this.guestModel;
    };

    this.setContactNumber = function (contactNumber) { 
        this.guestModel.contactNumber = contactNumber;
        return this;
    };
    this.setName = function (name) { 
        this.guestModel.name = name;
        return this;
    };
    this.setTerms = function (terms) { 
        this.guestModel.terms = terms;
        return this;
    };
    this.setPrivacy = function (privacy) { 
        this.guestModel.privacy = privacy;
        return this;
    };
    this.setMarket = function (market) { 
        this.guestModel.market = market;
        return this;
    };
}